import { useKeyboardLayoutMap } from './useKeyboardLayoutMap';

const BACKQUOTE_CODE = 'Backquote';
const DEFAULT_KEY_LABEL = '`';

/**
 * Detects the character produced by the physical Backquote key (left of 1)
 * on the user's keyboard layout. Returns the layout-specific label
 * (e.g., "`" for US QWERTY, "^" for German QWERTZ).
 */
export const useBackquoteKeyLabel = (): { keyLabel: string } => {
  const keyLabel = useKeyboardLayoutMap()?.get(BACKQUOTE_CODE) || DEFAULT_KEY_LABEL;
  return { keyLabel };
};
